<template>
  <div class="introduce_wrap">
    <h1 @click="toAbout">全球领先的MEC整体方案服务商</h1>
    <div class="describe">
      <p>2014年，欧洲电信标准协会ETSI提出5G演进架构和MEC概念</p>
      <p>2015年，星耀智能核心团队启动MEC场景研究和技术开发</p>
      <p>2016年，成功申请“一种对移动终端的业务分流方法及设置”等6项MEC相关知识产权</p>
      <p>2017年，启动MEC商业化应用</p>
      <p>2018年，成功部署七大场景应用</p>
    </div>
    <div class="more">
      <a href="about.html">了解更多 ></a>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    toAbout() {
      location.href="about.html"
    }
  }
}
</script>

<style lang="scss" scoped>
  .introduce_wrap {
    height: 354px;
    background: #fff;
    padding-top: 100px;
    text-align: center;
    h1 {
      color: #2C3B5C;
      font-size: 36px;
      line-height: 36px;
      margin-bottom: 30px;
      text-align: center;
      cursor: pointer;
    }
    .describe {
      display: inline-block;
      width: 640px;
      margin-bottom: 30px;
      p {
        text-align: center;
        color: #555E73;
        font-size: 16px;
        line-height: 28px;
        /* font-family:PingFangSC-Regular; */
      }
    }
    .more {
      text-align: center;
      a {
        font-weight: bold;
        font-size: 16px;
        color: #0EAEE5;
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/index/introduce.vue